module.exports = __webpack_public_path__ + "static/media/pengaturan.ffeb6596.png";